import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// MUI v5
import {
  TextField,
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, MenuItem, FormHelperText, Select, InputLabel,
  CircularProgress,
  Typography
} from '@mui/material';

import MyButton from '../../../utils/MyButton';
import { postCronogramaCalAuto, getServiciosEquipos, getListaCalFiltrado, clearErrors } from '../../../redux/actions/dataactions';
import { getTecnicos } from '../../../redux/actions/useractions';

import { FaArrowLeft, FaPlus, FaFirstAid, FaCheck, FaCheckCircle } from "react-icons/fa";
import './CronogramaMtoAuto.css';

export class CronogramaCalAuto extends Component {
  constructor() {
    super();
    this.state = {
      servicio: '',
      idprestador: '',
      fecha: '',
      frecuencia: 'anual',      // ahora seleccionable por el usuario
      responsable: 'Todos',     // default "Todos"
      lugar: '',
      errors: {},
      aprobado: {},
      open: false
    };
  }

  static getDerivedStateFromProps(props) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length ? newState : null;
  }

  componentDidMount() {
    if (this.props.clienteId) {
      this.props.getServiciosEquipos(this.props.clienteId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true, errors: {}, aprobado: {} });
    this.props.getTecnicos(this.props.handleuser);
    if (this.props.clienteId) {
      this.props.getServiciosEquipos(this.props.clienteId);
    }
  };

  handleClose = () => {
    const { credentials } = this.props.user;
    const { clienteId } = this.props;

    let responsable = "Todos";
    if (credentials.tipouser === "Tecnico") {
      responsable = credentials.handle;
    }

    if (this.state.aprobado.mensaje) {
      this.props.getListaCalFiltrado(
        clienteId,
        "01/01/1950",
        "01/01/2035",
        responsable
      );
    }

    this.props.clearErrors();
    this.setState({
      servicio: '',
      idprestador: '',
      fecha: '',
      lugar: '',
      frecuencia: 'anual',
      responsable: 'Todos',
      open: false,
      errors: {},
      aprobado: {}
    });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { credentials } = this.props.user;
    let responsableForCall = "Todos";
    if (credentials.tipouser === "Tecnico") {
      responsableForCall = credentials.handle;
    }

    const fechamto = new Date(this.state.fecha);
    let day, mes, year, mesnombre, newfecha;

    if (fechamto.getDate() >= 30) {
      day = 1;
      mes = fechamto.getMonth() + 1;
      if (mes > 11) {
        mes = 0;
        year = fechamto.getFullYear() + 1;
      } else {
        year = fechamto.getFullYear();
      }
      newfecha = new Date(fechamto.setDate(day));
      newfecha = new Date(newfecha.setMonth(mes));
      mes = mes + 1;
      mesnombre = newfecha.toLocaleString('es-Es', { month: 'long' });
    } else {
      day = fechamto.getDate() + 1;
      mes = fechamto.getMonth() + 1;
      year = fechamto.getFullYear();
      mesnombre = fechamto.toLocaleString('es-Es', { month: 'long' });
    }

    const newUserData = {
      servicio: this.state.servicio,
      fecha: this.state.fecha,
      lugar: this.state.lugar,
      idprestador: this.props.clienteId,
      dia: day || "",
      mes: mes || "",
      year: year || "",
      mesnombre: mesnombre || "",
      responsable: this.state.responsable, // desde desplegable
      frecuencia: this.state.frecuencia    // ahora seleccionado por el usuario
    };

    this.props.postCronogramaCalAuto(newUserData, this.props.clienteId, responsableForCall);
  };

  // Opciones de servicio robustas ante distintos formatos de datos
  getServicioOptions = () => {
    const data = this.props.data || {};
    const list = Array.isArray(data.serviciosEquipos)
      ? data.serviciosEquipos
      : (Array.isArray(data.servicios) ? data.servicios : []);

    const values = [...new Set(
      list.map(s =>
        typeof s === 'string'
          ? s
          : (s?.servicio || s?.nombre || s?.name || '')
      )
    )].filter(Boolean);

    return ['Todos', ...values];
  };

  render() {
    const { UI: { loading }, tecnicos } = this.props;
    const { errors } = this.state;

    const servicioOptions = this.getServicioOptions();
    const tecnicoOptions = Array.isArray(tecnicos) ? tecnicos : [];

    return (
      <Fragment>
        <div className='div-card-link' onClick={this.handleOpen}>
          <div className="dashing-cardcontent">
            <div className="dashing-cardtext">
              <p className="dashing-text-card">Generar Cronograma Automático</p>
            </div>
            <div className="dashing-cardicon">
              <FaFirstAid color="#FFFFFF" className="dashing-icon" />
            </div>
          </div>
        </div>

         <Dialog
                  open={this.state.open}
                  onClose={this.handleClose}
                  fullWidth
                  maxWidth="sm"
                >

{this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Programación Generada Exitosamente</h2>
              </div>
                
                ):(<div>

                   <DialogTitle >
           <Typography sx={{ 
                                                      fontSize: '20px', 
                                                      fontWeight: 600, 
                                                      color: '#0468BF', 
                                                      textAlign: 'center' 
                                                  }}>
                                                      Generar Cronograma de Calibración Automático
                            </Typography>
           
          </DialogTitle>

          <DialogContent>
            <form>

              {/* Servicio (desplegable) */}
              <div className="flex-accordion">
                <Typography 
                      variant="subtitle1"
                      sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        mb: 1,
                      }}
                    >
                      Servicio a Programar
                    </Typography>
                <FormControl className="formcontrol-nuevocliente" fullWidth error={Boolean(errors.servicio)}>
                 
                  <InputLabel id="servicio-label">Servicio</InputLabel>
                  <Select
                    labelId="servicio-label"
                    id="servicio"
                    name="servicio"
                    label="Servicio"
                    required
                    value={this.state.servicio || ''}
                    onChange={this.handleChange}
                  >
                    {servicioOptions.map((sv) => (
                      <MenuItem key={sv} value={sv}>{sv}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.servicio}</FormHelperText>
                </FormControl>
              </div>

              {/* Frecuencia (desplegable) */}
              <div className="flex-accordion">
               <Typography 
                      variant="subtitle1"
                      sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        mb: 1,
                      }}
                    >
                      Frecuencia
                    </Typography>
                <FormControl className="formcontrol-nuevocliente" fullWidth error={Boolean(errors.frecuencia)}>
                  <InputLabel id="frecuencia-label">Frecuencia</InputLabel>
                  <Select
                    labelId="frecuencia-label"
                    id="frecuencia"
                    name="frecuencia"
                    label="Frecuencia"
                    required
                    value={this.state.frecuencia}
                    onChange={this.handleChange}
                  >
                    <MenuItem value="trimestral">Trimestral</MenuItem>
                    <MenuItem value="semestral">Semestral</MenuItem>
                    <MenuItem value="anual">Anual</MenuItem>
                  </Select>
                  <FormHelperText>{errors.frecuencia}</FormHelperText>
                </FormControl>
              </div>

              {/* Fecha */}
              <div className="flex-accordion">
                <Typography 
                      variant="subtitle1"
                      sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        mb: 1,
                      }}
                    >
                      Fecha a programar la calibración
                    </Typography>
                <div className="input_divido">
                  <div className="input_divido_children">
                    <TextField
                      className="login-input-email"
                      required
                      type="date"
                      name="fecha"
                      id="fecha"
                      label="Fecha de Mantenimiento"
                      value={this.state.fecha}
                      onChange={this.handleChange}
                      min="2019-01-01"
                      max="2029-01-01"
                      fullWidth
                      helperText={errors.fecha}
                      error={Boolean(errors.fecha)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </div>
              </div>

              {/* Lugar */}
              <div className="flex-accordion">
                <Typography 
                      variant="subtitle1"
                      sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        mb: 1,
                      }}
                    >
                      Lugar de Calibración
                    </Typography>
                <FormControl className="formcontrol-nuevocliente" fullWidth error={Boolean(errors.lugar)}>
                  <InputLabel id="lugar-label">Lugar de Calibración</InputLabel>
                  <Select
                    labelId="lugar-label"
                    name="lugar"
                    id="lugar"
                    label="Lugar de Calibración"
                    required
                    value={this.state.lugar || ''}
                    onChange={this.handleChange}
                    fullWidth
                  >
                    <MenuItem value="Laboratorio">Laboratorio</MenuItem>
                    <MenuItem value="En Sitio">En Sitio</MenuItem>
                  </Select>
                  <FormHelperText>{errors.lugar}</FormHelperText>
                </FormControl>
              </div>

              {/* Responsable (desplegable) */}
              <div className="flex-accordion">
                <Typography 
                      variant="subtitle1"
                      sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        mb: 1,
                      }}
                    >
                      Responsable
                    </Typography>
                <FormControl className="formcontrol-nuevocliente" fullWidth error={Boolean(errors.responsable)}>
                  <InputLabel id="responsable-label">Seleccione un responsable</InputLabel>
                  <Select
                    labelId="responsable-label"
                    id="responsable"
                    name="responsable"
                    label="Seleccione un responsable"
                    value={this.state.responsable}
                    onChange={this.handleChange}
                  >
                    <MenuItem value="Todos">Todos</MenuItem>
                    {(Array.isArray(tecnicos) ? tecnicos : []).map((h, idx) => (
                      <MenuItem key={`${h}-${idx}`} value={h}>{h}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.responsable}</FormHelperText>
                </FormControl>
              </div>

            </form>
          </DialogContent>
                  
                </div>)}

                         <DialogActions>
                                     <MyButton tip="Cerrar" onClick={this.handleClose}>
                                     <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
                                      </MyButton>
                                      {loading ? (
                                         <CircularProgress size={30} color="primary" className="login-progress" />
                                       ) : (
                                         this.state.aprobado.mensaje ? (
                                           <MyButton tip="Continuar" onClick={this.handleClose}>
                                             <FaCheckCircle color="#0cae1aff" className="icon-formulario" />
                                           </MyButton>
                                         ) : (
                                           <MyButton tip="Generar Cronograma" onClick={this.handleSubmit}>
                                             <FaPlus color="#03178C" className="icon-formulario" />
                                           </MyButton>
                                         )
                                       )}
                                     
                                    </DialogActions>

                </Dialog>


       
      </Fragment>
    );
  }
}

CronogramaCalAuto.propTypes = {
  postCronogramaCalAuto: PropTypes.func.isRequired,
  getServiciosEquipos: PropTypes.func.isRequired,
  getListaCalFiltrado: PropTypes.func.isRequired,
  getTecnicos: PropTypes.func.isRequired,
  clienteId: PropTypes.string.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  data: PropTypes.object,
  handleuser: PropTypes.string,
  tecnicos: PropTypes.array
};

const mapActionsToProps = {
  postCronogramaCalAuto,
  getTecnicos,
  getListaCalFiltrado,
  getServiciosEquipos,
  clearErrors
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
  UI: state.UI,
  handleuser: state.user.credentials.handle,
  tecnicos: state.user.tecnicos
});

export default connect(mapStateToProps, mapActionsToProps)(CronogramaCalAuto);